export const TOP_10_INCREASE_CODE = 'machungkhoan';
export const TOP_10_INCREASE_CLOSE_PRICE = 'giadongcua';
export const TOP_10_INCREASE_CHANGE = 'thaydoi';
export const TOP_10_INCREASE_TRADING_VALUE = 'tradingValue';
export const TOP_10_INCREASE_TRADING_VOLUME = 'tradingVolume';
export const TOP_10_INCREASE_ICON = 'icon';

export const TOP_10_LOWEST_CODE = 'machungkhoan';
export const TOP_10_LOWEST_CLOSE_PRICE = 'giadongcua';
export const TOP_10_LOWEST_CHANGE = 'thaydoi';
export const TOP_10_LOWEST_TRADING_VALUE = 'tradingValue';
export const TOP_10_LOWEST_TRADING_VOLUME = 'tradingVolume';
export const TOP_10_LOWEST_ICON = 'icon';

export const TOP_10_TRADING_VALUE_CODE = 'machungkhoan';
export const TOP_10_TRADING_VALUE = 'tradingValue';
export const TOP_10_TRADING_VALUE_CHANGE = 'thaydoi';
export const TOP_10_TRADING_VALUE_ICON = 'icon';

export const TOP_10_TRADING_VOLUME_CODE = 'machungkhoan';
export const TOP_10_TRADING_VOLUME = 'tradingVolume';
export const TOP_10_TRADING_VOLUME_CHANGE = 'thaydoi';
export const TOP_10_TRADING_VOLUME_ICON = 'icon';

export const TOP_5_NEGOTIABLE_TRADING_VALUE = 'machungkhoan';
export const TOP_5_NEGOTIABLE_TRADING_VALUE_PUT_THROUGH = 'putThroughValue';
export const TOP_5_NEGOTIABLE_TRADING_VALUE_CHANGE = 'thaydoi';
export const TOP_5_NEGOTIABLE_TRADING_VALUE_ICON = 'icon';

export const TOP_5_NEGOTIABLE_TRADING_VOLUME = 'machungkhoan';
export const TOP_5_NEGOTIABLE_TRADING_VOLUME_PUT_THROUGH = 'putThroughValue';
export const TOP_5_NEGOTIABLE_TRADING_VOLUME_CHANGE = 'thaydoi';
export const TOP_5_NEGOTIABLE_TRADING_VOLUME_ICON = 'icon';

export const TOP_8_VOLUME_SECTOR = 'machungkhoan';
export const TOP_8_VOLUME_SECTOR_TRADING_VOLUME = 'tradingVolume';
export const TOP_8_VOLUME_SECTOR_ICON = 'icon';

export const TOP_8_VALUE_SECTOR = 'machungkhoan';
export const TOP_8_VALUE_SECTOR_TRADING_VOLUME = 'tradingValue';
export const TOP_8_VALUE_SECTOR_ICON = 'icon';

export const TOP_10_GO_UP_GO_DOWN_CODE = 'machungkhoan';
export const TOP_10_GO_UP_GO_DOWN_TRADING_VOLUME = 'tradingVolume';
export const TOP_10_GO_UP_GO_DOWN_TRADING_VALUE = 'tradingValue';
export const TOP_10_GO_UP_GO_DOWN_CHANGE = 'thaydoi';
export const TOP_10_GO_UP_GO_DOWN_ICON = 'icon';

export const top10IncreaseHeads = [
  {
    id: TOP_10_INCREASE_ICON,
    disablePadding: false,
    isSort: false,
    label: '',
    numeric: true,
    className: 'whitespace-nowrap',
  },
  {
    id: TOP_10_INCREASE_CODE,
    disablePadding: false,
    isSort: false,
    label: 'Mã CK',
    className: 'whitespace-nowrap',
  },
  {
    id: TOP_10_INCREASE_CLOSE_PRICE,
    disablePadding: false,
    isSort: false,
    label: 'Đóng cửa',
    className: 'whitespace-nowrap',
    numeric: true,
  },
  {
    id: TOP_10_INCREASE_CHANGE,
    disablePadding: false,
    isSort: false,
    label: 'Thay đổi',
    className: 'whitespace-nowrap',
    numeric: true,
  },
  {
    id: TOP_10_INCREASE_TRADING_VALUE,
    disablePadding: false,
    isSort: false,
    label: 'GTGD(tỷ)',
    className: 'whitespace-nowrap',
    numeric: true,
  },
  {
    id: TOP_10_INCREASE_TRADING_VOLUME,
    disablePadding: false,
    isSort: false,
    label: 'KLGD(cp)',
    className: 'whitespace-nowrap',
    numeric: true,
  },
];

export const top10LowestHeads = [
  {
    id: TOP_10_LOWEST_ICON,
    disablePadding: false,
    isSort: false,
    label: '',
    numeric: true,
    className: 'whitespace-nowrap',
  },
  {
    id: TOP_10_LOWEST_CODE,
    disablePadding: false,
    isSort: false,
    label: 'Mã CK',
    className: 'whitespace-nowrap',
  },
  {
    id: TOP_10_LOWEST_CLOSE_PRICE,
    disablePadding: false,
    isSort: false,
    label: 'Đóng cửa',
    className: 'whitespace-nowrap',
    numeric: true,
  },
  {
    id: TOP_10_LOWEST_CHANGE,
    disablePadding: false,
    isSort: false,
    label: 'Thay đổi',
    className: 'whitespace-nowrap',
    numeric: true,
  },
  {
    id: TOP_10_LOWEST_TRADING_VALUE,
    disablePadding: false,
    isSort: false,
    label: 'GTGD(tỷ)',
    className: 'whitespace-nowrap',
    numeric: true,
  },
  {
    id: TOP_10_LOWEST_TRADING_VOLUME,
    disablePadding: false,
    isSort: false,
    label: 'KLGD(cp)',
    className: 'whitespace-nowrap',
    numeric: true,
  },
];

export const top10TradingValueHeads = [
  {
    id: TOP_10_TRADING_VALUE_ICON,
    disablePadding: false,
    isSort: false,
    label: '',
    numeric: true,
    className: 'whitespace-nowrap',
  },
  {
    id: TOP_10_TRADING_VALUE_CODE,
    disablePadding: false,
    isSort: false,
    label: 'Mã CK',
    className: 'whitespace-nowrap',
  },
  {
    id: TOP_10_TRADING_VALUE,
    disablePadding: false,
    isSort: false,
    label: 'GTGD(tỷ)',
    numeric: true,
    className: 'whitespace-nowrap',
  },
  {
    id: TOP_10_TRADING_VALUE_CHANGE,
    disablePadding: false,
    isSort: false,
    label: 'Thay đổi',
    numeric: true,
    className: 'whitespace-nowrap',
  },
];

export const top10TradingVolumeHeads = [
  {
    id: TOP_10_TRADING_VOLUME_ICON,
    disablePadding: false,
    isSort: false,
    label: '',
    numeric: true,
    className: 'whitespace-nowrap',
  },
  {
    id: TOP_10_TRADING_VOLUME_CODE,
    disablePadding: false,
    isSort: false,
    label: 'Mã CK',
    className: 'whitespace-nowrap',
  },
  {
    id: TOP_10_TRADING_VOLUME,
    disablePadding: false,
    isSort: false,
    label: 'KLGD(cp)',
    className: 'whitespace-nowrap',
    numeric: true,
  },
  {
    id: TOP_10_TRADING_VOLUME_CHANGE,
    disablePadding: false,
    isSort: false,
    label: 'Thay đổi',
    className: 'whitespace-nowrap',
    numeric: true,
  },
];

export const top5NegotiableTradingValueHeads = [
  {
    id: TOP_5_NEGOTIABLE_TRADING_VALUE,
    disablePadding: false,
    isSort: false,
    label: 'Mã CK',
    className: 'whitespace-nowrap',
  },
  {
    id: TOP_5_NEGOTIABLE_TRADING_VALUE_PUT_THROUGH,
    disablePadding: false,
    isSort: false,
    label: 'GTGD',
    numeric: true,
    className: 'whitespace-nowrap',
  },
  {
    id: TOP_5_NEGOTIABLE_TRADING_VALUE_CHANGE,
    disablePadding: false,
    isSort: false,
    label: 'Thay đổi',
    numeric: true,
    className: 'whitespace-nowrap',
  },
  {
    id: TOP_5_NEGOTIABLE_TRADING_VALUE_ICON,
    disablePadding: false,
    isSort: false,
    label: '',
    numeric: true,
    className: 'whitespace-nowrap',
  },
];

export const top5NegotiableTradingVolumeHeads = [
  {
    id: TOP_5_NEGOTIABLE_TRADING_VOLUME,
    disablePadding: false,
    isSort: false,
    label: 'Mã CK',
    className: 'whitespace-nowrap',
  },
  {
    id: TOP_5_NEGOTIABLE_TRADING_VOLUME_PUT_THROUGH,
    disablePadding: false,
    isSort: false,
    label: 'KLGD',
    className: 'whitespace-nowrap',
    numeric: true,
  },
  {
    id: TOP_5_NEGOTIABLE_TRADING_VOLUME_CHANGE,
    disablePadding: false,
    isSort: false,
    label: 'Thay đổi',
    className: 'whitespace-nowrap',
    numeric: true,
  },
  {
    id: TOP_5_NEGOTIABLE_TRADING_VOLUME_ICON,
    disablePadding: false,
    isSort: false,
    label: '',
    numeric: true,
  },
];

export const top8VolumeSectorHeads = [
  {
    id: TOP_8_VOLUME_SECTOR_ICON,
    disablePadding: false,
    isSort: false,
    label: '',
    numeric: true,
  },
  {
    id: TOP_8_VOLUME_SECTOR,
    disablePadding: false,
    isSort: false,
    label: 'Mã CK',
    className: 'whitespace-nowrap',
  },
  {
    id: TOP_8_VOLUME_SECTOR_TRADING_VOLUME,
    disablePadding: false,
    isSort: false,
    label: 'KLGD',
    className: 'whitespace-nowrap',
    numeric: true,
  },
];

export const top8ValueSectorHeads = [
  {
    id: TOP_8_VALUE_SECTOR_ICON,
    disablePadding: false,
    isSort: false,
    label: '',
    numeric: true,
  },
  {
    id: TOP_8_VALUE_SECTOR,
    disablePadding: false,
    isSort: false,
    label: 'Mã CK',
    className: 'whitespace-nowrap',
  },
  {
    id: TOP_8_VALUE_SECTOR_TRADING_VOLUME,
    disablePadding: false,
    isSort: false,
    label: 'GTGD',
    className: 'whitespace-nowrap',
    numeric: true,
  },
];

export const top10GoDownByStockUpHeads = [
  {
    id: TOP_10_GO_UP_GO_DOWN_CODE,
    disablePadding: false,
    isSort: false,
    label: 'Mã CK',
    className: 'whitespace-nowrap',
  },
  {
    id: TOP_10_GO_UP_GO_DOWN_TRADING_VOLUME,
    disablePadding: false,
    isSort: false,
    label: 'KLGD TB 60 phiên',
    numeric: true,
    className: 'whitespace-nowrap',
  },
  {
    id: TOP_10_GO_UP_GO_DOWN_TRADING_VALUE,
    disablePadding: false,
    isSort: false,
    label: 'GTGD TB 60 phiên',
    numeric: true,
    className: 'whitespace-nowrap',
  },
  {
    id: TOP_10_GO_UP_GO_DOWN_CHANGE,
    disablePadding: false,
    isSort: false,
    label: 'Thay đổi',
    numeric: true,
    className: 'whitespace-nowrap',
  },
  {
    id: TOP_10_GO_UP_GO_DOWN_ICON,
    disablePadding: false,
    isSort: false,
    label: '',
    numeric: true,
    className: 'whitespace-nowrap',
  },
];

export const top10GoDownByStockDownHeads = [
  {
    id: TOP_10_GO_UP_GO_DOWN_CODE,
    disablePadding: false,
    isSort: false,
    label: 'Mã CK',
    className: 'whitespace-nowrap',
  },
  {
    id: TOP_10_GO_UP_GO_DOWN_TRADING_VOLUME,
    disablePadding: false,
    isSort: false,
    label: 'KLGD TB 60 phiên',
    numeric: true,
    className: 'whitespace-nowrap',
  },
  {
    id: TOP_10_GO_UP_GO_DOWN_TRADING_VALUE,
    disablePadding: false,
    isSort: false,
    label: 'GTGD TB 60 phiên',
    numeric: true,
    className: 'whitespace-nowrap',
  },
  {
    id: TOP_10_GO_UP_GO_DOWN_CHANGE,
    disablePadding: false,
    isSort: false,
    label: 'Thay đổi',
    numeric: true,
    className: 'whitespace-nowrap',
  },
  {
    id: TOP_10_GO_UP_GO_DOWN_ICON,
    disablePadding: false,
    isSort: false,
    label: '',
    numeric: true,
    className: 'whitespace-nowrap',
  },
];
